module.exports = __webpack_public_path__ + "static/media/wheel-alignment-red.82a57418.svg";